import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NavigationModule } from "@webapp/navigation/navigation.module";
import { SearchModule } from "@webapp/search/search.module";
import { UiButtonModule } from "@webapp/ui/button/button.module";
import { UiDividerModule } from "@webapp/ui/divider/divider.module";
import { UiGridModule } from "@webapp/ui/grid/grid.module";
import { UiIconModule } from "@webapp/ui/icon/icon.module";
import { UiTabModule } from "@webapp/ui/tab/tab.module";
import { TopNavBarComponent } from "./top-nav-bar.component";

@NgModule({
  imports: [NavigationModule, CommonModule, UiButtonModule, UiGridModule, SearchModule, UiIconModule, UiTabModule, UiDividerModule],
  declarations: [TopNavBarComponent],
  exports: [TopNavBarComponent],
})
export class TopNavBarModule {}
